<template>
  <section class="drag-and-drop-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <v-row class="mt-2">
      <v-col
        cols="12"
        v-for="(column, index) in activity.logged_answers.columns"
        :key="`cl-${index}`"
      >
        <span>{{ column.title }}</span>
        <ol>
          <li
            v-for="(a, dropIndex) in column.droppableItems"
            :key="`dr-${dropIndex}`"
          >
            {{ a.text }}
          </li>
        </ol>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'DragAndDrop',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.drag-and-drop-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }
}
</style>
